import React from 'react';
import { LinkData } from '../types';

interface Props {
  config: Record<string, any>;
  links: LinkData[];
}

export const VerticalLinkList: React.FC<Props> = ({ config, links }) => {
  // Use correct field names from types.ts
  const {
    moduleHeading = 'Related Articles',
    headingTag = 'h3',
    linkStyle = 'hover-underline',
    listStyle = 'none',
    maxLinks = 8,
    showViewMore = true,
    viewMoreText = 'View More',
    itemSpacing = 'normal',
  } = config;

  const displayLinks = links.slice(0, maxLinks);
  const HeadingTag = headingTag as keyof JSX.IntrinsicElements;

  // Get spacing based on itemSpacing config
  const getItemPadding = () => {
    switch (itemSpacing) {
      case 'tight':
        return '0.25rem 0';
      case 'relaxed':
        return '0.6rem 0';
      default:
        return '0.4rem 0';
    }
  };

  // Get link text decoration based on linkStyle
  const getLinkStyle = (): React.CSSProperties => {
    switch (linkStyle) {
      case 'underline':
        return { textDecoration: 'underline' };
      case 'none':
        return { textDecoration: 'none' };
      default: // hover-underline
        return { textDecoration: 'none' };
    }
  };

  // Get list style marker
  const getListStyleType = () => {
    switch (listStyle) {
      case 'bullets':
        return 'disc';
      case 'numbered':
        return 'decimal';
      default:
        return 'none';
    }
  };

  return (
    <div style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}>
      <HeadingTag
        style={{
          color: '#1e3a5f',
          marginBottom: '0.75rem',
          fontSize: '1.1rem',
          fontWeight: 600,
          margin: '0 0 0.75rem 0',
        }}
      >
        {moduleHeading}
      </HeadingTag>
      <ul
        style={{
          margin: 0,
          paddingLeft: listStyle !== 'none' ? '1.5rem' : 0,
          listStyleType: getListStyleType(),
        }}
      >
        {displayLinks.map((link, i) => (
          <li key={i} style={{ padding: getItemPadding() }}>
            <a
              href={link.url}
              style={{
                color: '#2db77a',
                ...getLinkStyle(),
                transition: 'color 0.2s',
              }}
            >
              {link.title || link.anchorText || link.url}
            </a>
          </li>
        ))}
      </ul>
      {showViewMore && links.length > maxLinks && (
        <a
          href="#"
          style={{
            display: 'inline-block',
            marginTop: '0.5rem',
            color: '#64748b',
            textDecoration: 'none',
            fontSize: '0.9rem',
          }}
        >
          {viewMoreText} →
        </a>
      )}
    </div>
  );
};
